import { useCallback } from 'react';
import { ToolbarItem } from '@kinesis/bungle';
import { Segment } from '@/components/inventory-toolbar';
import { DownloadButton } from '@/components/download-button';
import { useInventoryId } from '@/hooks/use-inventory-id';
import { usePathwayId } from '@/hooks/use-pathway-id';
import { useDownloadPathwayMutation, useGetPathwayQuery } from '@/api/pathways';
import { pathwayPath } from '@/links';

// Per-route toolbar for an open pathway (the detail view). Mirrors
// `toolbar-disclosure`: a single export button that downloads the *saved*
// pathway's evaluation as zipped CSVs; the signed URL is followed inside
// the mutation, so this just triggers it and spins on the in-flight flag.
const ToolbarPathway = () => {
  const pathwayId = usePathwayId();
  const [downloadPathway, { isLoading: isDownloading }] =
    useDownloadPathwayMutation();

  const onDownload = useCallback(() => {
    downloadPathway({ pathwayId });
  }, [pathwayId, downloadPathway]);

  return (
    <ToolbarItem>
      <DownloadButton downloading={isDownloading} onClick={onDownload}>
        Export as ZIP
      </DownloadButton>
    </ToolbarItem>
  );
};

// The breadcrumb tail for an open pathway: its name, linking back to the
// detail page (mirrors the legacy `ToolbarPathwayScenario`).
const ToolbarPathwayCrumb = () => {
  const inventoryId = useInventoryId();
  const pathwayId = usePathwayId();
  const { data: pathway, isSuccess } = useGetPathwayQuery(pathwayId);

  return isSuccess ? (
    <Segment to={pathwayPath(inventoryId, pathwayId)} label={pathway.name} />
  ) : null;
};

export { ToolbarPathway, ToolbarPathwayCrumb };
